import Button from "@mui/material/Button";

/** Botones outline legibles sobre fondo oscuro del panel WhatsApp. */
export const WA_OUTLINE_BTN_SX = {
  color: "#F8FAFC !important",
  borderWidth: "1.5px !important",
  borderStyle: "solid !important",
  borderColor: "rgba(248, 250, 252, 0.62) !important",
  backgroundColor: "rgba(255, 255, 255, 0.12)",
  fontWeight: 700,
  fontSize: "0.875rem",
  textTransform: "none",
  letterSpacing: "0.01em",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.28)",
  "&:hover": {
    color: "#FFFFFF !important",
    borderColor: "#38BDF8 !important",
    backgroundColor: "rgba(0, 117, 255, 0.22)",
    boxShadow: "0 0 0 1px rgba(56, 189, 248, 0.35)",
  },
  "&:focus-visible": {
    outline: "2px solid rgba(56, 189, 248, 0.75)",
    outlineOffset: 2,
  },
  "&:disabled": {
    color: "rgba(248, 250, 252, 0.42) !important",
    borderColor: "rgba(248, 250, 252, 0.28) !important",
    backgroundColor: "rgba(255, 255, 255, 0.04)",
    boxShadow: "none",
  },
};

export const WA_TABS_SX = {
  mb: 3,
  minHeight: 52,
  px: { xs: 0.5, sm: 1 },
  py: 0.5,
  borderRadius: "14px",
  backgroundColor: "rgba(6, 11, 38, 0.72)",
  border: "1px solid rgba(255, 255, 255, 0.16)",
  boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.07)",
  "& .MuiTabs-flexContainer": {
    gap: 0.5,
  },
  "& .MuiTabs-scrollButtons": {
    color: "#FFFFFF",
    width: 36,
    "&.Mui-disabled": {
      opacity: 0.3,
    },
  },
  "& .MuiTabs-indicator": {
    height: 3,
    borderRadius: "3px 3px 0 0",
    backgroundColor: "#38BDF8",
    boxShadow: "0 0 10px rgba(56, 189, 248, 0.55)",
  },
  "& .MuiTab-root": {
    color: "#CBD5E1 !important",
    fontWeight: 600,
    fontSize: { xs: "0.84rem", sm: "0.95rem" },
    textTransform: "none",
    letterSpacing: "0.02em",
    minHeight: 44,
    minWidth: { xs: "auto", sm: 110 },
    px: { xs: 2, sm: 2.5 },
    py: 1,
    opacity: 1,
    borderRadius: "10px",
    transition: "color 0.2s ease, background-color 0.2s ease",
    "&.Mui-selected": {
      color: "#FFFFFF !important",
      backgroundColor: "rgba(0, 117, 255, 0.22)",
    },
    "&:hover": {
      color: "#FFFFFF !important",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
};

export default function WaOutlineButton({ sx, size = "medium", ...props }) {
  return (
    <Button
      variant="outlined"
      size={size}
      sx={{ ...WA_OUTLINE_BTN_SX, ...sx }}
      {...props}
    />
  );
}
